import React from "react";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";

import * as colors from "../styles/colors";

const StyledCopy = styled(Box)`
  color: ${({ $color }) => $color || colors.text};
  font-size: ${({ $size }) => $size || "24px"};
  font-weight: ${({ $weight }) => $weight || 400};
  line-height: 150%;
  margin: 0;

  &.break-paragraph {
    display: block;
  }

  & .break-sm {
    margin: 12px 0 0 0;
  }

  @media (max-width: 480px) {
    font-size: ${({ $size }) => $size || "18px"};
    line-height: 135%;
  }
`;

export function Copy({
  color,
  size,
  weight,
  children,
  as = "p",
  ...props
}) {
  return (
    <StyledCopy
      {...props}
      as={as}
      $color={color}
      $size={size}
      $weight={weight}
    >
      {children}
    </StyledCopy>
  );
}
